import styled from "styled-components";

interface DropdownProps {
  isReport?: boolean;
  state?: boolean;
}

export const Dropdown = styled.div`
  position: relative;
`;
export const DropdownArea = styled.div.attrs({})<DropdownProps>`
  position: absolute;
  background: #ffffff;
  width: max-content;
  right: 0px;
  top: ${(props) => (props.isReport ? "" : "-43px")};
  text-align: center;

  box-shadow:
    0px 5px 5px -3px rgba(58, 53, 65, 0.2),
    0px 8px 15px 1px rgba(58, 53, 65, 0.14),
    0px 3px 50px 2px rgba(58, 53, 65, 0.12);
  border-radius: 6px;
  z-index: 9;
  display: ${(props) => (props.state ? "block" : "none")};
  padding: 0.5rem;
`;

export const DropdownUl = styled.ul`
  list-style: none;
  padding: 0;
`;

export const DropdownLi = styled.li`
  cursor: pointer;
  margin-top: 1rem;
  color: rgba(58, 53, 65, 0.87);
  //   &:not(first-child) {
  //     margin-top: 10px;
  //     border-top: 1px solid black;
  //     padding-top: 10px;
  //   }
`;

export const ReportDropdownArea = styled.div.attrs({
  className: "mt-2",
})<DropdownProps>`
  display: ${(props) => (props.state ? "block" : "none")};
  position: absolute;
  min-width: max-content;
  right: 0px;

  /* @media screen and (max-width: 425px) and (max-width: 320px) {
    right: 0px;
    left: 0px;
  } */
  @media screen and (max-width: 425px) and (min-width: 321px) {
    top: 7.5em;
    left: 50%;
    right: 50%;
    transform: translate(-50%, -50%);
  }
  @media screen and (max-width: 320px) {
    top: 7.5em;
    left: 190%;
    right: 50%;
    transform: translate(-50%, -50%);
  }
  box-shadow:
    0px 5px 5px -3px rgba(58, 53, 65, 0.2),
    0px 8px 15px 1px rgba(58, 53, 65, 0.14),
    0px 3px 50px 2px rgba(58, 53, 65, 0.12);
  padding: 1rem;
  border-radius: 6px;
  z-index: 1099;
  background-color: #fff;
`;
